import Vue from 'vue'
import VueBarcodeScanner from 'vue-barcode-scanner'

Vue.use(VueBarcodeScanner)
